

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Home from './components/Home';
import Contact from './components/Contact';
import Services from './components/Services';
import Careers from './components/Careers';
import About from './components/About';
import News from './components/News';
import Resources from './components/Resources';
import Conference from './components/Conference';
import OHSConsulting from './components/OHSConsulting'; // Add new components
import OHSConferences from './components/OHSConferences';
import OHSSupplies from './components/OHSSupplies';
import OHSEducation from './components/OHSEducation';
import Register from './components/Register'; // Add new components
import Blog from './components/Blog';
import SingleArticle from './components/SingleArticle';
import Photos from './components/Photos';
import Videos from './components/Videos';
import NewsArticles from './components/NewsArticles';

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services" element={<Services />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/about" element={<About />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/news" element={<News />} />
        <Route path="/conference" element={<Conference />} />
        <Route path="/services/consulting" element={<OHSConsulting />} />
        <Route path="/services/conferences" element={<OHSConferences />} />
        <Route path="/services/supplies" element={<OHSSupplies />} />
        <Route path="/services/education" element={<OHSEducation />} />
        <Route path="/media/photos" element={<Photos />} />
        <Route path="/media/videos" element={<Videos />} />
        <Route path="/media/newsarticles" element={<NewsArticles />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/singlearticle" element={<SingleArticle />} />
        <Route path="/register" element={<Register />} />
      </Routes>
    </Router>
  );
}

export default App;
